/**
 * @generated SignedSource<<7d14e98c3f25b8fa7cf51418eab466f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnterReportDraftInput = {
  reportId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type EnterReportDraftMutation$variables = {
  input: EnterReportDraftInput;
};
export type EnterReportDraftMutation$data = {
  readonly enterReportDraft: {
    readonly draftState: string | null;
    readonly publishedAt: string | null;
    readonly locked: boolean | null;
  } | null;
};
export type EnterReportDraftMutation = {
  variables: EnterReportDraftMutation$variables;
  response: EnterReportDraftMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnterReportDraftPayload",
    "kind": "LinkedField",
    "name": "enterReportDraft",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "draftState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnterReportDraftMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnterReportDraftMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d867f63c224679c74f776f768a6c3565",
    "id": null,
    "metadata": {},
    "name": "EnterReportDraftMutation",
    "operationKind": "mutation",
    "text": "mutation EnterReportDraftMutation(\n  $input: EnterReportDraftInput!\n) {\n  enterReportDraft(input: $input) {\n    draftState\n    publishedAt\n    locked\n  }\n}\n"
  }
};
})();

(node as any).hash = "20a1a291eb776de0ae542210819f7281";

export default node;
